import React, { FC } from "react";
import NewLayout from "@components/new-ui/Layout";
import HeaderImage from "@components/CaseStudyComponents/HeaderImage";
import AchievementCard from "@components/CaseStudyComponents/AchievementCard";
import Aside from "@components/CaseStudyComponents/Aside";
import About from "@components/CaseStudyComponents/About";
import Challenge from "@components/CaseStudyComponents/Challenge";
import Solution from "@components/CaseStudyComponents/Solution";
import Impact from "@components/CaseStudyComponents/Impact";
import RelatedCaseStudies from "@components/CaseStudyComponents/RelatedCaseStudies";
import ImageComponent from "@components/CaseStudyComponents/ImageComponent";
import Signup from "@components/CaseStudyComponents/Signup";
import Quote from "../../components/CaseStudyComponents/Quote";

const Page: FC = () => {
    const cardData = [
        {
            imgpath: "https://assets.gallabox.com/gb-home/case-study/Vector.png",
            title: "candidates",
            count: "2000+",
            by: "acquired by Bot ",
            borderColor: "#ACDAF1",
            boxShadowColor: "#D4ECF8",
            fontColor: "#3B7D9E",
            gradient: "linear-gradient(105.67deg, rgba(215, 235, 245, 0.2) 0%, #D7EBF5 95.66%)",
            customHeight: true,
        },
        {
            imgpath: "https://assets.gallabox.com/gb-home/case-study/Arrowup.png",
            title: "Minutes",
            count: "10,000",
            by: "Saved by Bot ",
            borderColor: "#C9E6AD",
            boxShadowColor: "#ECF8E1",
            fontColor: "#72A649",
            gradient: "linear-gradient(285.78deg, #ECF8E1 3.17%, rgba(236, 248, 225, 0.2) 96.84%)",
            customHeight: true,
        },
        {
            imgpath: "https://assets.gallabox.com/gb-home/case-study/Roboface.png",
            title: "Chats handled",
            count: "60%",
            by: "by Bot ",
            borderColor: "#DEBEF3",
            boxShadowColor: "#EFE1F8",
            fontColor: "#9461B5",
            gradient: "linear-gradient(285.94deg, #EFE1F8 1.79%, rgba(239, 225, 248, 0.2) 98.89%)",
            customHeight: true,
        },
    ];
    const RELATED_CASE_STUDIES = [
        {
            id: 1,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-2.png",
            title: "Sattvic Stores Reduced RTO by 10% within a month of using Gallabox..",
            link: "/case-study/sattvic-store",
            description:
                "Sattvic Stores by Kabir Innovations is an online retail marketplace selling organic health supplements, herbs, extracts, and more. They locally source ...",
        },
        {
            id: 2,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-1.png",
            title: "LivingStone Stays Relocated Their Communications From..",
            link: "/case-study/livingstone-stay",
            description:
                "Founded in 2019, LivingStone Stays is revolutionising the way people spend their leisure time - making holidays a way of life. Their platform is a one-stop ...",
        },
    ];

    return (
        <NewLayout
            title="Jobstars India - Case Study | Gallabox"
            description="Jobstars India Deployed a Multilingual Chatbot to Handle 60% of Candidate Conversations, Thereby Reducing 10,000 Minutes of Manual Agent Intervention"
            canonical="https://gallabox.com/case-study/jobstars-india"
        >
            <HeaderImage
                imagePath={"https://assets.gallabox.com/gb-home/case-study/group-people-working-out-business-plan.png"}
                imageText={"Jobstars India Deployed a Multilingual Chatbot to Handle 60% of Candidate Conversations, Thereby Reducing 10,000 Minutes of Manual Agent Intervention"}
            />
            <div className="max-w-md  sm:max-w-max mx-auto px-5 sm:px-10 lg:px-32 mt-20">
                <section className="max-w-6xl mx-auto flex flex-col items-center sm:flex-row gap-5 my-20 justify-between ">
                    {cardData.map((eachobj) => {
                        return (
                            <AchievementCard
                                key={""}
                                imagePath={eachobj.imgpath}
                                imageTitle={eachobj.title}
                                count={eachobj.count}
                                by={eachobj.by}
                                borderColor={eachobj.borderColor}
                                boxShadowColor={eachobj.boxShadowColor}
                                fontColor={eachobj.fontColor}
                                gradient={eachobj.gradient}
                            />
                        );
                    })}
                </section>
                <div className="max-w-6xl mx-auto flex flex-col sm:flex-row gap-8">
                    <div className="basis-1/5 mx-auto ">
                        <Aside
                            data={[
                                {
                                    title: "Company",
                                    content: "Jobstars India",
                                },
                                {
                                    title: "Industry",
                                    content: "HR & Professional Service",
                                },
                                {
                                    title: "Employees",
                                    content: "250+",
                                },
                                {
                                    title: "Product used",
                                    content: ["Multilingual Chatbot", "Google Sheet", "Integration", "Shared Team Inbox"],
                                },
                                {
                                    title: "Chats per Month",
                                    content: "5k+",
                                },
                                {
                                    title: "Website",
                                    link: "jobstarsindia.com ",
                                    content: "jobstarsindia.com ",
                                },
                            ]}
                        />
                    </div>
                    <main className="basis-4/5">
                        <About
                            aboutLogo={"https://assets.gallabox.com/gb-home/case-study/logo-about.png"}
                            aboutTitle={"Jobstars India"}
                            aboutContent={`Founded in 2002, Jobstars is one of the leading players in the Indian recruitment ecosystem. They believe in combining their passion for people with smart
                                            investments in intelligence technology to help organizations and talent realise their true potential. Employing over 319 specialist recruiters across our 3 office
                                            locations, JobStars HR Solutions Pvt. Ltd provides a full range of services including temporary and permanent staffing, outsourcing and other workforce solutions in
                                            the areas of engineering, finance, accounting, human resources, IT, manufacturing, logistics, sales and marketing.`}
                        />
                        <Challenge
                            challengeTitle={"Manual agent intensive workflow resulting in human errors"}
                            challengeList={[
                                "Manual agent intervention resulting in human errors like that of wrong application forms being sent to candidates. This was due to the vast number of job applications in different industry sectors.",
                                "Time-consuming workflow, in turn, resulting in delayed responses.",
                                "Drop-offs of candidates due to language barriers.",
                                "System of data to be sent or collected was done through several excel sheets which resulted in the loss of a common base of data collection.",
                                "Agents used multiple mobile numbers to acquire candidates. This diluted the main source of communication with the company.",
                            ]}
                        />
                        <ImageComponent caption={"The Solution Provided by Gallabox for Jobstars India."} imagelink={"https://assets.gallabox.com/gb-home/case-study/Group.png"} />
                        <Solution
                            solutionTitle={"A multilingual chatbot was deployed to take over candidate conversations and reduce redundancies "}
                            solutionContent={
                                "Gallabox created a multilingual rule-based chatbot to reduce drop-offs and reach a larger audience segment.The chatbot automated data collection parameters and provided the candidate with the right application forms reducing human intervention errors. Data collected by the bot were directed to one common database that could be accessed by all with the organisation. The multi-agent login feature of Gallabox helped Jobstar's agents to access conversations under one single WhatsApp number."
                            }
                            solutionData={[]}
                        />
                        <Quote
                            quoteText={`"Gallabox is our official chat partner. The simple & elegant automated chat response system made our business processes easy & hassle free. We are happy to use
                                        Gallabox, as all our business needs were fulfilled under one roof. Thank you team for your extended support."`}
                            quoteBy={"- A. Kamalahasan,"}
                            position={"Managing Director for Jobstar"}
                            paddingx={"px-7 sm:px-10 lg:px-16"}
                        />
                        <Impact
                            impactContent={[
                                `<li class="content">
                    The multilingual chatbot facilitated an increase in candidate applications and <span class="text-blue-color">sales by 60%</span>
                    </li>`,
                                `<li class="content">
                    This also resulted in <span class="text-blue-color">40% reduction</span> in manual agent intervention, thereby increasing the response rate and accuracy of
                    data shared and collected.
                </li>`,
                                `<li class="content">
                Jobstars acquired 2000+ customers within 2 months with the help of Gallabox's Chatbot which <span class="text-blue-color">saved 10,000 minutes</span>of
                human intervention.
            </li>`,
                                ` <li class="content">
            Jobstar's agents could <span class="text-blue-color">easily access candidate </span>conversations on the go via our mobile application and team inbox.
        </li>`,
                            ]}
                        />
                    </main>
                </div>
            </div>
            <Signup img="https://assets.gallabox.com/gb-home/case-study/Robot.png" content="Want similar results?" btn="Sign Up For A Free Trial" />
            <RelatedCaseStudies sectionDescription="Related Case Studies" related={RELATED_CASE_STUDIES} />
        </NewLayout>
    );
};

export default Page;
